module.exports = __webpack_public_path__ + "static/media/content-1.68f9f85d.png";